const time2callPageData = {
  slug: "time2call",
  title: "Time2Call",
  introduction:
    "An intelligent and powerful tool that accurately predicts when consumers will answer telemarketing calls — improving contact rates, reducing wasted dials and maximising campaign performance.",
  hero: {
    eyebrow: "Telemarketing Intelligence",
    align: "left",
    highlights: [
      { value: "20M+", label: "Intelligent disposition elements" },
      { value: "6", label: "Dial preference categories" },
      { value: "↑", label: "Contact rates & conversion" },
      { value: "↓", label: "Recontact costs & wasted calls" },
    ],
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "what-is-time2call",
      variant: "feature",
      icon: "insights",
      title: "What is Time2Call?",
      content: [
        "If you are involved in tele-marketing, Time2Call is a must-have tool. Built from historical and live telephone transactional data comprising over 20 million intelligent disposition elements, Time2Call enables you to accurately flag the time of day, evenings or weekends when consumers are most likely to be at home and ready to receive your call.",
        "By flagging your campaign data with a Time2Call preference, you reduce costly recontact strategies, talk with consumers at a time most convenient to them, and increase your chances of a successful outcome. Available per campaign or via a long-term multi-usage licence.",
      ],
    },

    {
      id: "dial-preference-categories",
      title: "Dial Preference Categories",
      titleDivider: true,
      content: [
        "Every record is matched and batched to one of six identifiable contact preferences:",
      ],
    },
    {
      type: "benefits",
      variant: "pillars",
      items: [
        { title: "Mornings" },
        { title: "Afternoons" },
        { title: "Evenings" },
        { title: "Weekends" },
        { title: "Anytime" },
        { title: "Do Not Call" },
      ],
    },

    {
      id: "why-it-matters",
      title: "Why It Matters",
      titleDivider: true,
      content: [
        "Dialling when people are not at home costs time and money, wastes resources and demotivates call centre agents. Repeated no-answers are dropped from automatic diallers — meaning you lose potential customers entirely.",
      ],
    },
    {
      type: "benefits",
      variant: "checklist",
      items: [
        { title: "Put data in the dialler at exactly the right time" },
        { title: "Reduce costly recontact strategies significantly" },
        { title: "Convenient for consumers — reducing complaints" },
        { title: "'Do Not Call' preferences removed automatically" },
        { title: "Increase likelihood of a successful outcome" },
        { title: "Improve call agent efficiency and morale" },
      ],
    },

    {
      type: "benefits",
      variant: "outcomes",
      heading: "Features & Benefits",
      titleDivider: true,
      items: [
        {
          title: "Improve contact rates",
          description: "Saves time and cost of recontact",
        },
        {
          title: "Predict when consumers are home",
          description: "Convenient for consumer & agent",
        },
        {
          title: "Data in the dialler at the right time",
          description: "Increased campaign efficiency",
        },
        {
          title: "Call at the most convenient time",
          description: "Reduced consumer complaints",
        },
        {
          title: "Managed service available",
          description: "Operator licence option",
        },
      ],
    },

    {
      id: "built-on-data",
      variant: "feature",
      icon: "insights",
      title: "Built on 20M+ Intelligent Disposition Elements",
      content: [
        "Time2Call is built from historical and live telephone transactional data, including consumer preferences and repeated transactional activity — compiled and modelled to predict the optimal contact time for each individual consumer. Data is matched to Mornings, Afternoons, Evenings, Weekends, Anytime or Do Not Call preferences automatically.",
      ],
    },

    {
      id: "flexible-access",
      title: "Flexible Access Options",
      titleDivider: true,
      content: [
        "Use Time2Call on a campaign-by-campaign basis for maximum flexibility, or access greater per-match savings with the annual multi-usage licence — ideal for high-volume telemarketing operations.",
      ],
    },

    {
      id: "cta-highlight",
      variant: "feature",
      icon: "phone",
      title: "Get Started",
      cta: { label: "Enquire now", href: "#enquiry" },
    },
  ],

  // Pricing intentionally not published — see implementation notes.
  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "Time2Call",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "Time2Call - Lloyd James Data Consultancy",
    description:
      "Time2Call predicts the best time to call consumers using 20M+ intelligent disposition elements — improving contact rates and cutting recontact costs.",
    keywords:
      "Time2Call, telemarketing intelligence, dial preference categories, intelligent disposition elements, contact rate optimisation, telemarketing calling data, Lloyd James",
    canonical: "/time2call/",
  },
};

export default time2callPageData;
